module.exports = __webpack_public_path__ + "static/media/img_image@3x.3193e921.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SP/@3x/img_image@3x.jpg
// module id = 1012
// module chunks = 0